import React, {useRef} from 'react';
import {GetTextColor, HexToRGBA, LightenColor} from "../../../ColorFunctions";
import {
    CCText,
    TouchableWithoutFeedback, View
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";

const MenuHeaderTabs = ({ menuSections, config, setCurrentSection, setMenuSections, sectionRefs, setUserScrolled, currentSection }, ref) => {
    const lightPrimaryColor = LightenColor(config.primaryColor, 0.8)


    return <div
        ref={ref}
        style={{
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            overflowY: 'hidden',
            backgroundColor: config.primaryColor,
            padding: 15
        }}>
        {menuSections.map(item => {
            let backgroundStyle = { backgroundColor: lightPrimaryColor };
            let textStyle = {};

            if (item.selected) {
                backgroundStyle = { backgroundColor: 'white' }
                textStyle = {
                    color: 'black', //GetTextColor(config.primaryColor),
                    fontWeight: 'bold'
                };
            }

            return <TouchableWithoutFeedback
                key={item.id}
                style={{ margin: '0 5px' }}
                onPress={() => {
                    const menuSectionsCopy = [...menuSections];
                    let currentSectionCopy = { ...currentSection };

                    for (let i = 0; i < menuSectionsCopy.length; i++) {
                        if (menuSectionsCopy[i].id == item.id) {
                            menuSectionsCopy[i].selected = true;

                            currentSectionCopy = menuSectionsCopy[i];
                        } else
                            menuSectionsCopy[i].selected = false;
                    }

                    const sectionRef = sectionRefs.current[currentSectionCopy.id];
                    if (sectionRef) {
                        const yOffset = sectionRef.getBoundingClientRect().top + window.pageYOffset - 150;
                        window.scrollTo({ top: yOffset, behavior: "smooth" });
                    }

                    setUserScrolled(true);
                    setMenuSections(menuSectionsCopy);
                    setCurrentSection(currentSectionCopy);
                }}
            >
                <View style={{
                    padding: '3px 10px',
                    borderRadius: '25px',
                    ...backgroundStyle
                }}>
                    <CCText className={"ws-nowrap"} style={{
                        fontSize: 16,
                        color: GetTextColor(lightPrimaryColor), ...textStyle
                    }}>
                        {item.name}
                    </CCText>
                </View>
            </TouchableWithoutFeedback>;
        })}
    </div>;
}

export default React.forwardRef(MenuHeaderTabs);